import {Injectable} from '@angular/core';
import {AbstractProdSelectService, IProdSelectProperties} from 'prod-select';

@Injectable({
  providedIn: 'root'
})

export class BatteryEventTypeService extends AbstractProdSelectService {
  override selectDataUrl: string = 'batteryEventTypes';
  override selectProperties: IProdSelectProperties = {
    id: 'id',
    name: 'name'
  };
}
